module.exports = __webpack_public_path__ + "fonts/3fc2c41.ttf";